import { BASE_URL } from "../../../Constant";
export const API_LANDMARK_SAVE : string = BASE_URL + '/api/landmark';
export const API_LOAD_ALL_LANDMARKS_FOR_BUSINESS_ID : string = BASE_URL + '/api/landmark/businessId';
export const API_LOAD_BY_LANDMARK_ID : string = BASE_URL + '/api/landmark';
export const LANDMARK_NAME_MIN_LENGTH: number = 3;
export const LANDMARK_NAME_MAX_LENGTH: number = 100;